// src/utils/jobNumberSort.js
// jobnumsort-6a1f3d85 — sort job numbers as NUMBERS on the Jobs list.
//
// jobNumber is stored as a zero-padded string ("0042"), so a plain string compare
// puts "10000" before "9999" once an org passes four digits — or the moment one
// sets a starting number like 26000 in Settings → Numbering. A few legacy values
// carry a baked-in "#" (see formatJobNumber), and recurring projections, non-jobs
// and any job whose number never landed have none at all.
//
// Rules: compare by numeric value, ignoring surrounding spaces and one leading "#".
// A record with no usable number (missing, empty, or not digits) sorts LAST in
// BOTH directions, so flipping the column never floods the top with blanks.

export function parseJobNumber(value) {
  if (value === null || value === undefined) return null;
  const s = String(value).trim().replace(/^#/, '').trim();
  if (!/^\d+$/.test(s)) return null;
  return parseInt(s, 10);
}

// direction: 'ascending' | 'descending' (the JobManagementView sortConfig values).
export function compareJobNumbers(a, b, direction = 'ascending') {
  const na = parseJobNumber(a);
  const nb = parseJobNumber(b);
  if (na === null && nb === null) return 0;
  if (na === null) return 1;   // no number: last, whichever way
  if (nb === null) return -1;
  if (na === nb) return 0;
  const asc = na < nb ? -1 : 1;
  return direction === 'descending' ? -asc : asc;
}
